export const styles: { [key: string]: React.CSSProperties } = {
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '24px',
    minWidth: '24px',
    maxHeight: '24px',
    minHeight: '24px',
    border: '1px solid #E3DDE6',
    borderRadius: '4px',
    color: '#655C68',
  },
};
